import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { DisplayProps, OpacityProps, PositionProps, ZIndexProps } from 'styled-system';
import { display, opacity, position, zIndex } from 'styled-system';

import { outlineCSS } from '../../theme/styles';

const UnstyledRadioInput = styled.input<DisplayProps & OpacityProps & PositionProps & ZIndexProps>`
  ${display};
  ${opacity};
  ${position};
  ${zIndex};

  &:disabled + label > svg {
    opacity: 0.5;
  }

  &:focus-visible + label > svg {
    ${outlineCSS};
    border-radius: 50%;
  }
`;

const RadioInput = (props: ComponentProps<typeof UnstyledRadioInput>) => (
  <UnstyledRadioInput type="radio" position="absolute" opacity={0} zIndex={-1} {...props} />
);

export default RadioInput;
